import React, { FC } from 'react';
import { useStore } from 'common/store';
import { CapTableVersion } from 'common/types/company';
import { UseStoreValues } from 'common/types/store';
import { GridSelect } from 'components/FeaturedSpreadsheet/components';
import { getArrayValue } from 'utilities';


interface CapTableVersionSelectorProps {
  options?: CapTableVersion[];
}

const CapTableVersionSelector: FC<CapTableVersionSelectorProps> = ({ options: optionsProp, ...props }) => {
  const [storeValue] = useStore() as unknown as UseStoreValues;
  const { capTableList } = storeValue;

  const selectProps = {
    menuPosition: 'absolute',
    objectOptions: { displayKey: 'name', valueKey: 'id' },
    options: getArrayValue(optionsProp ?? capTableList),
  };

  return <GridSelect {...props} {...selectProps} />;
};

export default CapTableVersionSelector;
